var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path, _path2, _path3, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCulture03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.458984,
    y: 0.826172,
    width: 350,
    height: 233,
    fill: "#B8693D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.097,
    cy: 100.441,
    rx: 6.53888,
    ry: 6.51117,
    fill: "#F8CCA4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.026,
    cy: 82.0865,
    rx: 5.52789,
    ry: 5.50447,
    fill: "#F8CCA4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.637,
    cy: 89.8619,
    rx: 7.80905,
    ry: 7.77595,
    fill: "#F8CCA4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.282,
    cy: 83.7369,
    rx: 7.80905,
    ry: 7.77595,
    fill: "#F8CCA4"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.963,
    cy: 77.1197,
    rx: 7.80905,
    ry: 7.77595,
    fill: "#F8CCA4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.751,
    cy: 101.694,
    rx: 12.9012,
    ry: 12.8465,
    fill: "#F8CCA4"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.494,
    cy: 91.5121,
    rx: 11.4022,
    ry: 11.3539,
    fill: "#F8CCA4"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.494,
    cy: 100.44,
    rx: 11.4022,
    ry: 11.3539,
    fill: "#F8CCA4"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 289.027,
    cy: 84.8968,
    rx: 11.4022,
    ry: 11.3539,
    fill: "#F8CCA4"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 258.497,
    cy: 91.5123,
    rx: 7.80905,
    ry: 7.77595,
    fill: "#F8CCA4"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.776,
    cy: 104.302,
    rx: 11.6878,
    ry: 11.6383,
    fill: "#F8CCA4"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.06,
    cy: 99.242,
    rx: 9.03024,
    ry: 8.99197,
    fill: "#F8CCA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.652 105.29C226.472 104.009 227.537 102.897 228.824 103.021L246.801 104.757L267.299 105.537L287.78 104.826L305.765 103.03C307.055 102.902 308.125 104.015 307.945 105.299L299.513 165.343H283.406H267.299H251.192H235.085L226.652 105.29Z",
    fill: "#FCD2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.652 105.228L235.085 165.344H251.192L246.799 104.755L228.832 102.96C227.542 102.831 226.472 103.944 226.652 105.228Z",
    fill: "#5848BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.299 165.344V105.536L287.799 104.755L283.406 165.344H267.299Z",
    fill: "#5848BD"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.673,
    cy: 95.795,
    rx: 4.35057,
    ry: 4.33213,
    fill: "#EBAC72"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.80712,
    cy: 2.23003,
    rx: 1.80712,
    ry: 2.23003,
    transform: "matrix(0.719106 0.694901 -0.697947 0.71615 252.352 89.0293)",
    fill: "#EBAC72"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.80712,
    cy: 2.23003,
    rx: 1.80712,
    ry: 2.23003,
    transform: "matrix(0.719106 0.694901 -0.697947 0.71615 246.074 95.9902)",
    fill: "#EBAC72"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.29208,
    cy: 3.30072,
    rx: 3.29208,
    ry: 3.30072,
    transform: "matrix(0.277635 -0.960687 0.961311 0.275466 250.689 97.6387)",
    fill: "#EBAC72"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.569,
    cy: 87.0065,
    rx: 3.27233,
    ry: 3.25846,
    fill: "#EBAC72"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.412,
    cy: 91.9242,
    rx: 4.38421,
    ry: 4.36563,
    fill: "#EBAC72"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.927,
    cy: 84.5364,
    rx: 4.12031,
    ry: 4.10285,
    fill: "#EBAC72"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.76,
    cy: 94.4044,
    rx: 2.86768,
    ry: 2.85553,
    fill: "#EBAC72"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.29,
    cy: 87.9739,
    rx: 5.00679,
    ry: 4.98557,
    fill: "#EBAC72"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture03);
export default __webpack_public_path__ + "static/media/culture_03.b20254f3e5835e477bc9fecdf0897df7.svg";
export { ForwardRef as ReactComponent };